<template style="height:100%">
  <div class="Project">
    <div class="Project_top">

      <el-form style="padding: 20px;" :inline="true" :model="from" class="demo-form-inline">

        <el-form-item label="活动类型">
          <el-select v-model="from.eventType" placeholder="活动区域">
            <el-option label="全部" value="0"></el-option>
            <el-option label="体验型" value="1"></el-option>
            <el-option label="治疗性" value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- 和周确定好0是全部 -->
        <el-form-item label="审批进度">
          <el-select v-model="from.eventStatus" placeholder="审批进度">
            <el-option label="全部" value="0"></el-option>
            <el-option label="已通过" value="3"></el-option>
            <el-option label="驳回" value="4"></el-option>
            <el-option label="拒绝" value="5"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit()">查询</el-button>
          <el-button type="primary" @click="reset()">重置</el-button>
        </el-form-item>

      </el-form>



 
<!-- 
      <div class="Project_div">
        <span>活动类型：</span>
        <ul>
          <li @click="query1(0, '')" style="cursor:pointer;">全部</li>
          <li @click="query1(1, '')" style="cursor:pointer;">体验型</li>
          <li @click="query1(2, '')" style="cursor:pointer;">治疗性</li>
        </ul>
      </div>

      

      <div class="Project_div">
        <span>审批进度：</span>
        <ul>
          <li @click="query2('', 0)" style="cursor:pointer;">全部</li>
          <li @click="query2('', 3)" style="cursor:pointer;">已通过</li>
          <li @click="query2('', 4)" style="cursor:pointer;">驳回修改</li>
          <li @click="query2('', 5)" style="cursor:pointer;">拒绝</li>
        </ul>
      </div>

      <div class="Project_div">
        <span>举办形式：</span>
        <ul>
          <li @click="query3(0, '')" style="cursor:pointer;">全部</li>
          <li @click="query3(2, '')" style="cursor:pointer;">线下活动</li>
          <li @click="query3(1, '')" style="cursor:pointer;">自助活动</li>
        </ul>
      </div> -->
    </div>

    <div class="Project_nav">
      <div class="Project_nav_top">
        <el-button type="primary" icon="el-icon-plus" @click="project_approval()">申请立项</el-button>
        <el-button plain @click="delfun()">删除</el-button>

        <el-table v-loading="loadings" :data="tableData" :row-key="(row) => { return row.eventKey; }"
          style="width: 100%; margin-top: 10px" :default-sort="{ prop: 'date', order: 'descending' }"
          @selection-change="handleSelectionChange"  >

          <el-table-column type="selection" :reserve-selection="true" width="55" :selectable="isRowSelectable"></el-table-column>
        
          <el-table-column label="活动主题" min-width="100" align="left">
            <template slot-scope="scope" align="left">
              <span>{{ scope.row.subject }}</span>
            </template>
          </el-table-column>

          <el-table-column label="活动类型" min-width="100" align="left">
            <template slot-scope="scope" align="left">
              <span>{{ scope.row.eventType == 1 ? "体验型活动" : "治疗性活动" }}</span>
            </template>
          </el-table-column>

          <el-table-column label="活动形式" min-width="100" align="left">
            <template slot-scope="scope" align="left">
              <span>{{ scope.row.eventRate == 1 ? "单次" : "连续" }}</span>
            </template>
          </el-table-column>

          <el-table-column label="立项人" min-width="100" align="left">
            <template slot-scope="scope" align="left">
              <span>{{ scope.row.creatorName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="审批状态" min-width="100" align="left">
            <template slot-scope="scope" align="left">
              <span v-if="scope.row.eventStatus == 1">立项</span>
              <span v-if="scope.row.eventStatus == 2">审核中</span>
              <span v-if="scope.row.eventStatus == 3">审核通过</span>
              <span v-if="scope.row.eventStatus == 4">驳回修改</span>
              <span v-if="scope.row.eventStatus == 5">拒绝</span>
              <span v-if="scope.row.eventStatus == 6">发布</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="100" align="left">
            <template slot-scope="scope" align="left">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button type="text" @click="open(scope.row,1)" size="small">
                查看
              </el-button>
              <el-button v-if="scope.row.eventStatus == 1 || scope.row.eventStatus == 4" type="text" @click="open(scope.row,2)" size="small">
                修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="from.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="test2" :visible.sync="dialogVisible" :before-close="handleClose">

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="活动主题：" prop="Subject">
          <el-input v-model="ruleForm.Subject"></el-input>
        </el-form-item>

        <el-form-item label="封面" prop="cover" >
          <div class="cover" style="margin-left:-70px">
            <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
              <img v-if="fmimageUrl" :src="fmimageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon">
                <span style="font-size: 16px;">点击选择封面</span>
              </i>
            </el-upload>
          </div>
          <p style="font-size: 12px;line-height: 20px;">推荐使用800X450像素的图片，或者16:9比例的.jpg/.png图片，为保证显示效果，图片应该美观、紧扣主题。</p>
        </el-form-item>

        <el-form-item label="活动类型：" prop="EventType">
          <el-radio-group v-model="ruleForm.EventType">
            <el-radio label="1">体验型活动</el-radio>
            <el-radio :disabled = 'people' label="2">治疗性活动</el-radio>
            <!-- <el-radio label="2">治疗性活动</el-radio> -->
          </el-radio-group>
        </el-form-item>

        <el-form-item label="举办形式：" prop="HoldType">
          <el-radio-group v-model="ruleForm.HoldType">
            <el-radio label="1">线下活动</el-radio>
            <!-- <el-radio label="2">自助活动</el-radio> -->
            <el-radio label="3">线下加线上</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="内容分类：" prop="PrePaperCode">
          <el-select v-model="ruleForm.Classificationdata" placeholder="请选择">
            <el-option v-for="item in Classification" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="活动形式：" prop="EventRate">
          <el-radio-group v-model="ruleForm.EventRate" @change="agreeChange">
            <el-radio label="1">单次</el-radio>
            <el-radio label="2">连续</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="间隔周期：" prop="ContinueType" v-if="ruleForm.EventRate == '2'">
          <el-radio-group v-model="ruleForm.ContinueType" @change="agreeChange2">
            <el-radio label="1">周</el-radio>
            <el-radio label="2">月</el-radio>
            <el-radio label="3">自定义</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="举办日期：" prop="EventDate" v-if="!AsxL">
          <el-date-picker :clearable="false" v-model="ruleForm.EventDate" type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>

        <el-form-item label="举办时间：" prop="EventTime" v-if="!AsxL" >
          <el-time-picker :clearable="false" is-range v-model="ruleForm.EventTime" format="HH:mm" value-format="HH:mm" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"> </el-time-picker>
        </el-form-item>
        
        <el-form-item label="举办日期：" prop="EventDate" v-else>
          <el-date-picker :clearable="false" @change="ccslkj2" v-model="ruleForm.EventDate" type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <el-form-item label="举办时间：" prop="EventTime" style="margin-top:10px;" v-if="xiaoliandong">
            <el-time-picker :clearable="false" @change="ccslkj" is-range v-model="ruleForm.EventTime" format="HH:mm" value-format="HH:mm" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
            </el-time-picker>
          </el-form-item>

          <ul class="timedata">
            <li v-for="(item, index) in timedata" :key="index">
              {{ item.toString().slice(0,10) }}日
              {{ item.toString().slice(22,27) }} 至
              {{ item.toString().slice(11,21) }}日
              {{ item.toString().slice(28,33) }}
              <div class="el-icon-close" @click="bfds(index)"></div>
            </li>
          </ul>
        </el-form-item>

        <el-form-item label="开始报名时间：" prop="SignStartTime">
          <el-date-picker v-model="ruleForm.SignStartTime"  format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="结束报名时间：" prop="SignEndTime">
          <el-date-picker v-model="ruleForm.SignEndTime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="活动地点：" prop="Address">
          <el-input v-model="ruleForm.Address" placeholder="请输入活动地点"></el-input>
        </el-form-item>

        <el-form-item label="活动对象：" prop="EventLimit">
          <el-radio-group v-model="ruleForm.EventLimit">
            <el-radio label="1" :disabled='!people2'>院内活动</el-radio>
            <el-radio label="2" :disabled='people2'>外院联合活动</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="参加活动院系：">
          <el-cascader :disabled = 'people2' ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" :options="options" :props="{ multiple: true, checkStrictly: true}" collapse-tags :placeholder="deps"></el-cascader>
        </el-form-item>

        <el-form-item label="活动人数：" prop="SignNum">
          <el-input v-model="ruleForm.SignNum" placeholder="请输入活动人数"></el-input>
        </el-form-item>

        <el-form-item class="sxgg" label="活动内容：" prop="EvenContent">
          <el-input type="textarea" v-model="ruleForm.EvenContent" placeholder="请输入活动内容"></el-input>
        </el-form-item>

        <el-form-item label="活动预算（选填）：">
          <el-input type='number' v-model="ruleForm.EventBudget" placeholder="请输入活动预算"></el-input>
        </el-form-item>

        <el-form-item label="是否需要预报名：" prop="PreSignFlg">
          <el-radio-group v-model="ruleForm.PreSignFlg">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="ruleForm.PreSignFlg == 1" prop="PreSignNum" label="限制报名人数：">
          <el-input v-model="ruleForm.PreSignNum" placeholder="请输入限制报名人数"></el-input>
        </el-form-item>

        <el-form-item v-if="ruleForm.PreSignFlg == '1'" label="预报名筛选表：" prop="PrePaperCode">
          <el-select v-model="ruleForm.PrePaperCode" placeholder="请选择">
            <el-option v-for="item in indexval2" :key="item.dicKey" :label="item.cDicValue" :value="item.cDicValue">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否招募志愿者：" prop="VolunteerFlg">
          <el-radio-group v-model="ruleForm.VolunteerFlg" @change="xaxcss">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="志愿者人数" prop="ReceiveNum"  v-show="ruleForm.VolunteerFlg == 1">
          <el-input v-model="ruleForm.ReceiveNum" placeholder="请输入志愿者人数"></el-input>
        </el-form-item>
 <!-- v-show="xaxcs" -->
        <el-form-item v-show="ruleForm.VolunteerFlg == 1" label="志愿者筛选表" prop="PrePaperCode">
          <el-select v-model="ruleForm.Volunteer_screening" placeholder="请选择">
            <el-option v-for="item in Volunteer_screeningdata" :key="item.dicKey" :label="item.cDicValue" :value="item.cDicValue">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="相关附件上传" prop="region">
          <el-upload :on-remove="handleRemove" action="" accept="" :auto-upload="false" :on-change="handleChanges" multiple :file-list="fileList2">
            <el-button class="video_btn iconfont icontianjia3">上传附件</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item label="活动负责人：" prop="ChargePerson">
          <el-select v-model="ruleForm.ChargePerson" placeholder="活动负责人">
            <el-option v-for="item in rendata.fzr" :key="item.userID" :label="item.name" :value="item.userID"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="负责人电话：" prop="chargePersonPhone">
          <el-input v-model="ruleForm.chargePersonPhone" placeholder="请输入负责人电话"></el-input>
        </el-form-item>

        <el-form-item label="积分：" prop="points">
          <el-input v-model="ruleForm.points" placeholder="请输入积分"></el-input>
        </el-form-item>

        <!-- <el-form-item label="证书内容：" prop="certificateTitle">
          <el-input v-model="ruleForm.certificateTitle" placeholder="请输入证书内容"></el-input>
        </el-form-item> -->

        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button :loading="losads" type="primary" @click="submitForm('ruleForm')">{{test1}}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>

    <el-dialog title="选择审批负责人" :visible.sync="dialogVisibles" width="30%">
      <div class="wapprovers">
        <div class="wapprovers_left">
          <el-input></el-input>
          <el-button type="primary">搜索</el-button>

          <el-collapse v-model="activeNames">
            <el-collapse-item title="心理中心" name="1">
              <div class="sxbverd" style="cursor: pointer;" v-for="item in rendata.psychologist" :key="item.userID"
                @click="toren(item, '1062', '心理中心')">
                {{ item.name }}
              </div>
            </el-collapse-item>

            <el-collapse-item title="辅导员" name="2">
              <div class="sxbverd" style="cursor: pointer;" v-for="item in rendata.instructor" :key="item.userID" @click="toren(item, '1063', '辅导员')">
                {{ item.name }}
              </div>
            </el-collapse-item>

            <el-collapse-item title="系主任" name="3">
              <div class="sxbverd" style="cursor: pointer;" v-for="item in rendata.director" :key="item.userID" @click="toren(item, '1064', '系主任')">
                {{ item.name }}
              </div>
            </el-collapse-item>
            
            <!-- <el-collapse-item title="校长" name="4">
              <div class="sxbverd" v-for="item in rendata.principal" :key="item.userID" @click="toren(item, '1065', '校长')">
                {{ item.name }}
              </div>
            </el-collapse-item> -->

          </el-collapse>
        </div>

        <div class="wapprovers_right">
          <p>当前选中</p>
          <ul class="approverdata">
            <li v-for="item in lookren" style="cursor: pointer;" :key="item.index" @click="delete_lookren(item)">{{item.name}}</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibles = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibles = false">确 定</el-button>
      </span>

    </el-dialog>

    <el-dialog title="活动详情" :visible.sync="lookdialogVisible" width="50%" :before-close="handleClose">
      <ul class="lookul">
        <li><span>活动主题：</span>{{ looklist.subject }}</li>
        <li style="height: 130px;position: relative;"><span style="position: absolute;top:0px">活动封面:</span> <img style="width: 200px;height: 120px;position: absolute;left:70px" :src="looklist.coverPath" alt=""> </li>
        <li><span>活动类型：</span>{{ looklist.eventType == 1?'体验型活动':'治疗性活动' }}</li>
        <li><span>活动形式：</span>{{ looklist.eventRate == 1?'单次':'连续' }}</li>
        <!-- <li><span>内容分类：</span>{{ looklist.classification}}</li>  -->
        <li>
          <span style="padding-top:10px;display: inline-block;" v-for="(item,i) in looklist.tget" :key="i">
            举办时间{{ looklist.tget.length>1? i+1:'' }}：
            <span style="color: rgb(32, 32, 32);">
            {{item.eventStartTimeString}}日 {{item.eventStartTiming}} 至{{item.eventEndTimeString}}日{{item.eventEndTiming}}
            </span>
            <br>
          </span>
        </li>
        <!-- <li><span>举办结束时间：</span>{{ looklist.eventEndTime }} - {{looklist.eventEndTiming}}</li> -->
        <li><span>开始报名时间：</span>{{ looklist.signStartTime }}</li>
        <li><span>结束报名时间：</span>{{ looklist.signEndTime }}</li>
        <li><span>活动地点：</span>{{ looklist.address }}</li>
        <!-- <li><span>活动内容：</span>{{ looklist.evenContent }} <span @click="domw()" style="color: #298FE8;margin-left: 20px;cursor: pointer;">下载附件</span></li> -->
        <li><span>活动对象：</span>{{ looklist.eventLimit == 1?'院内活动':'外院联合活动' }}</li>
        <li><span>活动人数：</span>{{ looklist.signNum }}</li>
        <li>
          <span>参加活动院系：</span>
          <span style="margin-left: 5px;" v-for="item in looklist.tged" :key="item.deptID">{{ item.deptName }}</span>
        </li>
        <li><span>活动预算：</span>{{ looklist.eventBudget }}</li>
        <li><span>活动是否需要预报名：</span>{{ looklist.preSignFlg == 0 ? "不需要预报名" : "需要预报名" }}</li>
        <li><span>限制报名人数：</span>{{ looklist.preSignNum }}</li>
        <li><span>预报名筛选表：</span>{{ looklist.prePaperCode }}</li>
        <li><span>是否招募志愿者：</span>{{ looklist.volunteerFlg == 0 ? "不招募志愿者" : "招募志愿者" }}</li>
        <li v-if="looklist.volunteerFlg == 1"><span>志愿者人数：</span>{{ looklist.receiveNum }}</li>
        <li v-if="looklist.volunteerFlg == 1"><span>志愿者筛选表：</span>{{ looklist.volunteerPaperCode }}</li>
        <li><span>立项人：</span>{{ looklist.creatorName }}</li>
        <li><span>负责人：</span>{{ looklist.chargePerson }}</li>
        <li><span>负责人电话：</span>{{ looklist.chargePersonPhone }}</li>
        <li><span>积分：</span>{{ looklist.points }}</li>
      </ul>

      <div class="lookdiv">
        <h6>审批流程：</h6>
        <ul style="padding-bottom:40px">
          <li v-if="looklist.counselorAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
            <span>辅导员：</span>
            <span style="position: absolute;left: 100px; width: 80px;color: #298FE8;" v-if="looklist.counselorAudit == '1'">待审核</span>
            <span style="position: absolute;left: 100px; width: 80px;color: rgb(83 184 31);" v-if="looklist.counselorAudit == '2'">审核通过</span>
            <span style="position: absolute;left: 100px; width: 80px;color: rgb(228 80 46);" v-if="looklist.counselorAudit == '3'">审核拒绝</span>
            <span style="position: absolute;left: 100px; width: 80px;" v-if="looklist.counselorAudit == '4'">无需审核</span>
            <span style="position: absolute;left: 100px; width: 80px;color: rgb(228 80 46);" v-if="looklist.counselorAudit == '5'">审核驳回</span>
            <!-- <div style="width: 50px;height: 50px;position: absolute;right: 20px;top:10px; background-color: #298FE8;color: #fff;border-radius:50%;text-align:center; line-height: 50px;">{{ looklist.counselorName?looklist.counselorName:'无' }}</div> -->
          </li>

          <li v-if="looklist.chairManAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
            <span>系主任：</span>
            <span style="position: absolute;left: 100px;width:80px;color: #298FE8;" v-if="looklist.chairManAudit == '1'">待审核</span>
            <span style="position: absolute;left: 100px;width:80px;color: rgb(83 184 31);" v-if="looklist.chairManAudit == '2'">审核通过</span>
            <span style="position: absolute;left: 100px;width:80px;color: rgb(228 80 46);" v-if="looklist.chairManAudit == '3'">审核拒绝</span>
            <span style="position: absolute;left: 100px;width:80px;" v-if="looklist.chairManAudit == '4'">无需审核</span>
            <span style="position: absolute;left: 100px;width:80px;color: rgb(228 80 46);" v-if="looklist.chairManAudit == '5'">审核驳回</span>
            <!-- <div style="width: 50px;height: 50px;position: absolute;right: 20px;top:14px; background-color: #298FE8;color: #fff;border-radius:50%;text-align:center;line-height: 50px;">{{ looklist.chairManName?looklist.chairManName:'无'}}</div> -->
            <!-- <span style="display: inline-block;height: 50px;width: 50px;background-color: #298FE8;line-height: ;"></span> -->
          </li>

          <li v-if="looklist.associationPresidentAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
            <span>会长：</span>
            <span style="position: absolute;left: 100px;width:80px;color: #298FE8;" v-if="looklist.associationPresidentAudit == '1'">待审核</span>
            <span style="position: absolute;left: 100px;width:80px;color: rgb(83 184 31);" v-if="looklist.associationPresidentAudit == '2'">审核通过</span>
            <span style="position: absolute;left: 100px;width:80px;color: rgb(228 80 46);" v-if="looklist.associationPresidentAudit == '3'">审核拒绝</span>
            <span style="position: absolute;left: 100px;width:80px;" v-if="looklist.associationPresidentAudit == '4'">无需审核</span>
            <span style="position: absolute;left: 100px;width:80px;color: rgb(228 80 46);" v-if="looklist.associationPresidentAudit == '5'">审核驳回</span>
            <!-- <div style="width: 50px;height: 50px;position: absolute;right: 20px;top:14px; background-color: #298FE8;color: #fff;border-radius:50%;text-align:center;line-height: 50px;">{{ looklist.chairManName?looklist.chairManName:'无'}}</div> -->
            <!-- <span style="display: inline-block;height: 50px;width: 50px;background-color: #298FE8;line-height: ;"></span> -->
          </li>

          <li v-if="looklist.psyCenterAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
            <span>心理中心：</span>
            <span style="position: absolute;left: 100px;width: 80px;color: #298FE8;" v-if="looklist.psyCenterAudit == '1'">待审核</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(83 184 31);" v-if="looklist.psyCenterAudit == '2'">审核通过</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.psyCenterAudit == '3'">审核拒绝</span>
            <span style="position: absolute;left: 100px;width: 80px;" v-if="looklist.psyCenterAudit == '4'">无需审核</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.psyCenterAudit == '5'">审核驳回</span>
            <!-- <div style="width: 50px;height: 50px;position: absolute;right: 20px;top:14px;background-color: #298FE8;color: #fff;border-radius:50%;text-align:center; line-height: 50px;">{{ looklist.psyCenterName?looklist.psyCenterName:'无' }}</div> -->
          </li>

          <li v-if="looklist.centerDirectorAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
            <span>心理中心主任：</span>
            <span style="position: absolute;left: 100px;width: 80px;color: #298FE8;" v-if="looklist.centerDirectorAudit == '1'">待审核</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(83 184 31);" v-if="looklist.centerDirectorAudit == '2'">审核通过</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.centerDirectorAudit == '3'">审核拒绝</span>
            <span style="position: absolute;left: 100px;width: 80px;" v-if="looklist.centerDirectorAudit == '4'">无需审核</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.centerDirectorAudit == '5'">审核驳回</span>
            <!-- <div style="width: 50px;height: 50px;position: absolute;right: 20px;top:14px;background-color: #298FE8;color: #fff;border-radius:50%;text-align:center; line-height: 50px;">{{ looklist.psyCenterName?looklist.psyCenterName:'无' }}</div> -->
          </li>

          <li v-if="looklist.principalAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
            <span>校长：</span>
            <span style="position: absolute;left: 100px;width: 80px;color: #298FE8;" v-if="looklist.principalAudit == '1'">待审核</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(83 184 31);" v-if="looklist.principalAudit == '2'">审核通过</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.principalAudit == '3'">审核拒绝</span>
            <span style="position: absolute;left: 100px;width: 80px;" v-if="looklist.principalAudit == '4'">无需审核</span>
            <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.principalAudit == '5'">审核驳回</span>
            <div style="width: 50px;height: 50px;position: absolute;right: 20px;top:14px;background-color: #298FE8;color: #fff;border-radius:50%;text-align:center; line-height: 50px;">{{ looklist.PrincipalName?looklist.PrincipalName:'无' }}</div>
          </li>


        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      Volunteer_screeningdata:[],
      people2:false,
      fmimageUrl:'',
      fmcover:'',
      deps:'',
      test1:'立即创建',
      test2:'申请活动立项',
      losads:false,
      people:false,
      formInline: {},
      eventKeylist: [],//删除列表
      eventKey: '',//修改
      indexval2:[],
      looklist: '',
      lookdialogVisible: false,//查看详情
      xiaoliandong: false,//自定义内部联动
      Counts: 0,
      loadings: true,
      tableData: [],
      file2: [],
      wcascader: 1,
      cascade_list: [],
      lookren: [],
      chuanren: '',
      vdoi: '',
      approverdata: [],
      rendata: '',
      limitNum: 1,//上传excell时，同时允许上传的最大数
      fileList: [],
      fileList2: [],
      activeNames: ['1'],
      options: [],
      timedata: [],
      EventNo: Date.now(),
      dialogVisibles: false,
      dialogVisible: false,
      ContinueType: false,
      Intervaldays: false,
      xaxcs: false,
      AsxL: false,
      Classification:[],
      ruleForm: {
        Classificationdata:'',
        chargePersonPhone:'',
        Volunteer_screening:'',
        EventTime: ['08:00', '09:00'],
        EventDate: this.Global.querycensus(1),
        EventNo: Date.now(),
        Subject: "",
        EventType: "0",
        EventRate: "0",
        ContinueType: "0",
        HoldType: '1',
        RepeatFrequency: "",
        SignStartTime: "",
        SignEndTime: "",
        Address: "",
        EventLimit: "",
        SignNum: "",
        EvenContent: "",
        EventBudget: "",
        PreSignFlg: "0",
        PreSignNum: "",
        PrePaperCode: "",
        VolunteerFlg: "0",
        ReceiveNum: "",
        ArrangeNum: "9",
        OtherNum: "8",
        ChargePerson: "",
        Counselor: "",
        ChairMan: "",
        PsyCenter: "",
        DeptIDsss: '',
        spUserID: [],
        spRoleID: [],
        files: [],
        // EventNo:"",
        points:'',
        certificateTitle:'',
      },
      rules: {
        Subject: [{ required: true, message: '请输入活动主题', trigger: 'blur' }],
        Address: [{ required: true, message: '请输入活动地点', trigger: 'blur' }],
        EvenContent: [{ required: true, message: '请输入活动内容', trigger: 'blur' }],
        SignNum: [{ required: true, message: '请输入活动人数', trigger: 'blur' }],
        EventType: [{ required: true, message: '请选择活动类型', trigger: 'blur' }],
        EventRate: [{ required: true, message: '请选择活动次数', trigger: 'blur' }],
        SignStartTime: [{ required: true, message: '请选择开始报名时间', trigger: 'blur' }],
        SignEndTime: [{ required: true, message: '请选择结束报名时间', trigger: 'blur' }],
        ChargePerson: [{ required: true, message: '请选择活动负责人', trigger: 'blur' }],
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }, { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }],
        date1: [{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }],
        date2: [{ type: 'date', required: true, message: '请选择时间', trigger: 'change' }],
        type: [{ type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }],
        resource: [{ required: true, message: '请选择活动对象', trigger: 'change' }],
        desc: [{ required: true, message: '请填写活动形式', trigger: 'blur' }],
        // EventLimit2222: [{ required: true, message: '请选择活动对象', trigger: 'change' }],
        // PrePaperCode: [{ required: true, message: '请选择预报名筛选表', trigger: 'change' }],
        // ReceiveNum: [{ required: true, message: '请输入志愿者人数', trigger: 'blur' }],
      },
      from: {
        pageSize: 10,
        pageIndex: 1,
        holdType: 1,//举办方式 0代表线下发布或者立项  1代表自助活动 默认为0；
        eventType: '0',//活动类型 0全部 1全部 2全部 开始查询默认为2
        eventStatus: "0",//1-立项 2-审核中 3-审核通过 4-驳回修改 5-拒绝 6-发布 0 全部
        subject: '',//活动主题
        subjectTime: '',//活动日期
        times: '',//创建时间（查询自助活动用）
        region: '', 
      }
    };
  },
  methods: {
    isRowSelectable(row, index) {
      if (row.eventStatus == 2 || row.eventStatus == 6) {
        return false;//不可勾选
      } else {
        return true;//可勾选
      }
    },
    reset(){
      this.from.eventType = '0';
      this.from.region = '';
      this.from.eventStatus = '';
      this.from.pageIndex = 1;
      this.loading(this.from);
    },
    delfun() {
      if (this.eventKeylist.length >= 1) {
        var from = {
          eventKeys: this.eventKeylist
        }
        this.$Http_Post('/activitymanagement/deeventplan', { from: from }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.eventKeylist = [];
            this.loading();
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      } else {
        alert("未选择删除项")
      }
    },
    project_approval(){
      this.dialogVisible = true;
      this.fileList2 = [];
      this.test1 = '立即创建';
      this.test2 = '申请活动立项';
    },
    open(row,type) {//查看按钮事件
      this.test1 = '保存';
      this.test2 = '活动修改';
      var from = {eventKey: row.eventKey};
      this.$Http_Post('/activitymanagement/fxeventplan', { from: from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if (type == 1) {
            this.lookdialogVisible = true;
            this.looklist = res.Data;
            this.deps = [];
            for(var i = 0;i<res.Data.tged.length;i++){
              this.deps += res.Data.tged[i].deptName;
            }
          } else {
            this.deps = [];
            for(var i = 0;i<res.Data.tged.length;i++){
              this.deps += res.Data.tged[i].deptName;
            }
            this.dialogVisible = true;
            this.looklist = res.Data;
            this.eventKey = res.Data.eventKey;
            res.Data.tgea.forEach((tab, index) => {
              res.Data.tgea[index].name = tab.fileNM;
            })
            this.fileList2 = res.Data.tgea;

            console.log(this.fileList2)
            this.ruleForm.Volunteer_screening = res.Data.volunteerPaperCode

            this.fmimageUrl = res.Data.coverPath;
            this.ruleForm.EventTime = [res.Data.eventStartTiming, res.Data.eventEndTiming],//举办时间
            this.ruleForm.EventDate = [res.Data.eventStartTime, res.Data.eventEndTime],//举办日期
            this.ruleForm.EventNo = Date.now(),
            this.ruleForm.Subject = res.Data.subject,//活动主题：
            this.ruleForm.EventType = res.Data.eventType,//活动类型：
            this.ruleForm.EventRate = res.Data.eventRate,//活动形式：单次 多次
            this.ruleForm.ContinueType = res.Data.continueType,//间隔周期：
            this.ruleForm.HoldType = res.Data.holdType,//举办形式：
            this.ruleForm.SignStartTime = res.Data.signStartTime,//开始报名时间：
            this.ruleForm.SignEndTime = res.Data.signEndTime,//结束报名时间：
            this.ruleForm.Address = res.Data.address,//活动地点：
            this.ruleForm.EventLimit  = res.Data.eventLimit,//活动对象：
            this.ruleForm.SignNum = res.Data.signNum,//活动人数：
            this.ruleForm.EvenContent = res.Data.evenContent,//活动内容：
            this.ruleForm.EventBudget = res.Data.eventBudget,//活动预算（选填）：
            this.ruleForm.PreSignFlg = res.Data.preSignFlg,//是否需要预报名：
            this.ruleForm.PreSignNum = res.Data.preSignNum,//限制报名人数：
            this.ruleForm.PrePaperCode = res.Data.prePaperCode,//预报名筛选表：
            this.ruleForm.VolunteerFlg = res.Data.volunteerFlg,//是否招募志愿者：
            this.ruleForm.ReceiveNum = res.Data.receiveNum,//志愿者人数
            this.ruleForm.ArrangeNum = "9",//
            this.ruleForm.chargePersonPhone = res.Data.chargePersonPhone,//
            this.ruleForm.Classificationdata = res.Data.classification,//
            this.ruleForm.OtherNum = "8",//
            this.ruleForm.ChargePerson = res.Data.chargePersonID,//活动负责人：
            this.ruleForm.Counselor = "",//
            this.ruleForm.ChairMan = "",//
            this.ruleForm.PsyCenter = "",//
            this.ruleForm.spUserID = [],//
            this.ruleForm.spRoleID = [],//
            this.ruleForm.files = []//
            
            this.ruleForm.points = res.Data.points//
            this.ruleForm.certificateTitle = res.Data.certificateTitle//

            for(var i = 0;i<res.Data.tged.length;i++){
              this.ruleForm.DeptIDsss += res.Data.tged[i].deptID+',';
            }
          }
        }
      })
    },
    handleSelectionChange(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].eventKey);
      }
      this.eventKeylist = lsc;
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.from.pageIndex = val;
      this.loading(this.from);
    },
    query1(EventType, EventStatus) {
      this.from.eventType = EventType;
      this.loading(this.from);
    },
    onSubmit() {
      this.from.pageIndex = 1;
      this.loading(this.from);
    },
    query3(holdType) {
      this.from.holdType = holdType;
      this.loading(this.from);
    },
    loading() {
      this.$Http_Post('/activitymanagement/geteventplanlist', { from: this.from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Counts = res.Counts;
          this.tableData = res.Data;
          this.loadings = false;
        }
      })
    },
    Selected_to_shut_dow(dt) {
      var xs;
      for(var i = 0;i<dt.length;i++){
        if(i ==0){
          xs = dt[i] + '/';
        }else{
          xs += dt[i] + '/';
        }
      }
      this.ruleForm.DeptIDsss = xs;
    },

    bumen(dt) {
      let obj = this.options[0];
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].DeptID == dt[dt.length - 1]) {
          obj = this.options[i];
          break
        } else if (this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.options[i].children,
          )
        }
      }
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...' }]
        this.$Http_Post('/DepartMent/getalldepartmentbynode', {DeptID: dt[dt.length - 1],content: '',}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break;
        }
      }
      return obj;
    },
    delete_lookren(val) {
      this.lookren.splice(this.lookren.indexOf(val),1);
      if (val.type == '1') {
        this.ruleForm.Counselor = "";
      } else if (val.type == '2') {
        this.ruleForm.PsyCenter = "";
      } else if (val.type == '3') {
        this.ruleForm.ChairMan = "";
      }
    },
    toren(val, v, s) {
      if (s == '辅导员') {
        if (this.ruleForm.Counselor) {
          alert("只能添加一个辅导员审批角色");
        } else {
          this.ruleForm.Counselor = val.userID;
          val.type = 1;
          this.lookren.push(val);
          this.lookren = Array.from(new Set(this.lookren));
        }
      } else if (s == '心理中心') {
        if (this.ruleForm.PsyCenter) {
          alert("只能添加一个心理中心审批角色");
        } else {
          this.ruleForm.PsyCenter = val.userID;
          val.type = 2;
          this.lookren.push(val);
          this.lookren = Array.from(new Set(this.lookren));
        }
      } else if (s == '系主任') {
        if (this.ruleForm.ChairMan) {
          alert("只能添加一个系主任审批角色");
        } else {
          this.ruleForm.ChairMan = val.userID;
          val.type = 3;
          this.lookren.push(val);
          this.lookren = Array.from(new Set(this.lookren));
        }
      }
      this.chuanren = val.userID;
      this.vdoi = s;
    },
    handleChange(file, fileList) {
      this.fmimageUrl = URL.createObjectURL(file.raw);
      this.fmcover = file.raw;
    },
    ccslkj() {
      let times = [];
      times.push(this.ruleForm.EventDate);
      times.push(this.ruleForm.EventTime);
      this.timedata.push(times);
      this.ruleForm.EventDate = [];
      this.ruleForm.EventTime = ['',''];
    },
    //小联动改变值
    ccslkj2() {
      this.xiaoliandong = true;
    },
    bfds(val) {
      this.timedata.splice(val, 1);
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.closeAll();
      this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length } 个`);
    },
    enterSearch(ea) {},
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList.push(file.raw);
    },
    handleChanges(file, fileList) {
      if (fileList.length >= 2) {
        this.ruleForm.files = [];
        for (var i = 0; i < fileList.length; i++) {
          this.ruleForm.files.push(fileList[i].raw);
        }
      } else {
        this.ruleForm.files.push(fileList[0].raw);
      }
    },
    handleRemove(file, fileList) {
      this.ruleForm.files = [];
      if (fileList.length >= 2) {
        for (var i = 0; i < fileList.length; i++) {
          this.ruleForm.files.push(fileList[i].raw);
        }
      } else {
        this.ruleForm.files.push(fileList[0].raw);
      }
    },
    //上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {},
    //文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success("文件上传成功");
    },
    //文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败");
    },
    xaxcss() {
      if (this.ruleForm.VolunteerFlg == 1) {
        this.xaxcs = true;
      } else {
        this.xaxcs = false;
      }
    },
    agreeChange() {
      if (this.ruleForm.EventRate == 1) {
        this.ContinueType = true;
        this.Intervaldays = true;
      } else {
        this.ContinueType = false;
        this.Intervaldays = false;
      }
    },
// 周五晚上，上海凌桥回沈丘，车找人，联系17621610512
    agreeChange2() {
      this.ruleForm.EventTime = ['',''];
      if (this.ruleForm.ContinueType == 3) {
        this.Intervaldays = false;
        this.AsxL = true;
      } else {
        this.Intervaldays = true;
        this.AsxL = false;
      }
    },

    getWeeks(startDate,endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      let current = new Date(start);
      let weeks = [];
 
      while (current <= end) {
        // 获取当前周的开始和结束日期
        const weekStart = new Date(current);
        const weekEnd = new Date(current);
        weekEnd.setDate(weekEnd.getDate() + 6);
 
        // 如果周末超出了结束日期，则设置为结束日期
        if (weekEnd > end) {
          weekEnd.setDate(end.getDate());
        }
 
        weeks.push(this.formatDate(weekStart))

        // weeks.push({
        //   start: this.formatDate(weekStart),
        //   end: this.formatDate(weekEnd),
        // });
 
        // 移动到下一周
        current.setDate(current.getDate() + 7);
      }
      return weeks;
    },

    formatDate(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },

    getMonthlyPeriods(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const months = [];
      let currentMonth = new Date(startDate);
      // currentMonth.setDate(1); // 设置当月的第一天
      do {
        const monthStart = new Date(currentMonth);
        const nextMonth = currentMonth.getMonth() + 1;
        const monthEnd = new Date(currentMonth.getFullYear(), nextMonth, 0);
        months.push(this.formatDate2(monthStart));
        currentMonth.setMonth(currentMonth.getMonth() + 1);
      } while (currentMonth <= endDate);
      return months;
    },
    formatDate2(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },

    submitForm(formName) {
      // console.log( this.getWeeks(this.ruleForm.EventDate[0],this.ruleForm.EventDate[1]))
      console.log(this.getMonthlyPeriods(this.ruleForm.EventDate[0],this.ruleForm.EventDate[1]))
      if(this.ruleForm.EventLimit == 2){
        if(!this.ruleForm.DeptIDsss){
          alert("请选择参加活动院系!")
          return false
        }
      }
      if(this.test1 == '立即创建'){
        for (var i = 0; i < this.lookren.length; i++) {
          this.ruleForm.spUserID.push(this.lookren[i].userID);
          this.ruleForm.spRoleID.push(this.lookren[i].name);
        }
        if (this.timedata.length > 0) { this.ruleForm.EventTime = this.timedata }
        var from = new FormData()
        from.append('subject', this.ruleForm.Subject);
        from.append('eventType', this.ruleForm.EventType);
        from.append('eventRate', this.ruleForm.EventRate);
        if(this.ruleForm.EventRate == 2){//活动形式：1单2连续
          if(this.ruleForm.ContinueType == 1){//1周2月
            from.append('eventDate', this.getWeeks(this.ruleForm.EventDate[0],this.ruleForm.EventDate[1]));
          }else{
            from.append('eventDate', this.getMonthlyPeriods(this.ruleForm.EventDate[0],this.ruleForm.EventDate[1]));
            // this.getMonthlyPeriods(this.ruleForm.EventDate[0],this.ruleForm.EventDate[1])
          }
        }else{
          from.append('eventDate', this.ruleForm.EventDate);
        }

        from.append('continueType', this.ruleForm.ContinueType);
        from.append('eventTime', this.ruleForm.EventTime.join("/"));
        from.append('holdType', this.ruleForm.HoldType);
        from.append('signStartTime', this.ruleForm.SignStartTime);
        from.append('signEndTime', this.ruleForm.SignEndTime);
        from.append('address', this.ruleForm.Address);
        from.append('eventLimit', this.ruleForm.EventLimit);
        from.append('signNum', this.ruleForm.SignNum);
        from.append('evenContent', this.ruleForm.EvenContent);
        from.append('eventBudget', this.ruleForm.EventBudget);
        from.append('preSignFlg', this.ruleForm.PreSignFlg);
        from.append('preSignNum', this.ruleForm.PreSignNum);
        from.append('prePaperCode', this.ruleForm.PrePaperCode);
        from.append('volunteerFlg', this.ruleForm.VolunteerFlg);
        from.append('receiveNum', this.ruleForm.ReceiveNum);
        from.append('arrangeNum', this.ruleForm.ArrangeNum);
        from.append('otherNum', this.ruleForm.OtherNum);
        from.append('chargePerson', this.ruleForm.ChargePerson);
        from.append('counselor', this.ruleForm.Counselor);
        from.append('chairMan', this.ruleForm.ChairMan);
        from.append('psyCenter', this.ruleForm.PsyCenter);
        from.append('deptIDsss', this.ruleForm.DeptIDsss);
        from.append('spUserID', this.ruleForm.spUserID);
        from.append('spRoleID', this.ruleForm.spRoleID);
        from.append('classification', this.ruleForm.Classificationdata);
        from.append('coverPath', this.fmcover);
        from.append('chargePersonPhone', this.ruleForm.chargePersonPhone);
        from.append('volunteerPaperCode', this.ruleForm.Volunteer_screening);
        from.append('points', this.ruleForm.points);
        from.append('certificateTitle', this.ruleForm.certificateTitle);
        this.losads = true;
        for (let i = 0; i < this.ruleForm.files.length; i++) {
          from.append('files', this.ruleForm.files[i]);
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.ruleForm.PreSignFlg == 1){
              if(this.ruleForm.SignNum <= this.ruleForm.PreSignNum){
                if(!this.ruleForm.PrePaperCode){
                  this.Global.request_failure("请选择预报名筛选表");
                  this.losads = false
                  return false;
                }else{
                  this.$Http_Post('activitymanagement/addeventplan', from).then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                      this.losads = false;
                      this.dialogVisible = false;
                      this.loading(this.from);
                      this.Global.request_successful(res.Message);
                    } else {
                      this.losads = false;
                      this.Global.request_failure(res.Message);
                    }
                  })
                }
                
              }else{
                this.Global.request_failure("活动人数不能大于限制报名人数!");
                this.losads = false;
                return false;
              }
            }else{
              this.$Http_Post('activitymanagement/addeventplan', from).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  this.losads = false;
                  this.dialogVisible = false;
                  this.loading(this.from);
                  this.Global.request_successful(res.Message);
                } else {
                  this.losads = false;
                  this.Global.request_failure(res.Message);
                }
              })
            }
          } else {
            this.losads = false
            return false;
          }
        });
      }else{
        for (var i = 0; i < this.lookren.length; i++) {
          this.ruleForm.spUserID.push(this.lookren[i].userID);
          this.ruleForm.spRoleID.push(this.lookren[i].name);
        }
        if (this.timedata.length > 0) { this.ruleForm.EventTime = this.timedata }
        var from = new FormData()
        // from.append('eventNo', this.ruleForm.EventNo);
        from.append('eventKey', this.eventKey);
        from.append('subject', this.ruleForm.Subject);
        from.append('eventDate', this.ruleForm.EventDate);
        from.append('eventType', this.ruleForm.EventType);
        from.append('eventRate', this.ruleForm.EventRate);
        from.append('continueType', this.ruleForm.ContinueType);
        from.append('eventTime', this.ruleForm.EventTime.join("/"));
        from.append('holdType', this.ruleForm.HoldType);
        from.append('signStartTime', this.ruleForm.SignStartTime);
        from.append('signEndTime', this.ruleForm.SignEndTime);
        from.append('address', this.ruleForm.Address);
        from.append('eventLimit', this.ruleForm.EventLimit);
        from.append('signNum', this.ruleForm.SignNum);
        from.append('evenContent', this.ruleForm.EvenContent);
        from.append('eventBudget', this.ruleForm.EventBudget);
        from.append('preSignFlg', this.ruleForm.PreSignFlg);
        from.append('preSignNum', this.ruleForm.PreSignNum);
        from.append('prePaperCode', this.ruleForm.PrePaperCode);
        from.append('volunteerFlg', this.ruleForm.VolunteerFlg);
        from.append('receiveNum', this.ruleForm.ReceiveNum);
        from.append('arrangeNum', this.ruleForm.ArrangeNum);
        from.append('otherNum', this.ruleForm.OtherNum);
        from.append('chargePerson', this.ruleForm.ChargePerson);
        from.append('counselor', this.ruleForm.Counselor);
        from.append('chairMan', this.ruleForm.ChairMan);
        from.append('psyCenter', this.ruleForm.PsyCenter);
        from.append('deptIDsss', this.ruleForm.DeptIDsss);
        from.append('spUserID', this.ruleForm.spUserID);
        from.append('spRoleID', this.ruleForm.spRoleID);
        from.append('points', this.ruleForm.points);
        from.append('certificateTitle', this.ruleForm.certificateTitle);
        from.append('volunteerPaperCode', this.ruleForm.Volunteer_screening);

        this.losads = true;
        for (let i = 0; i < this.ruleForm.files.length; i++) { 
          if(typeof this.ruleForm.files[i] === 'number'){
            from.append('filest', this.ruleForm.files[i]);
          }else{
            from.append('files', this.ruleForm.files[i]);
          }
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.ruleForm.PreSignFlg == 1){

              if(this.ruleForm.SignNum <= this.ruleForm.PreSignNum){
                this.$Http_Post('/activitymanagement/upeventplan', from).then((res) => {
                  if (res.Code == 200 || res.Code == 0) {
                    this.losads = false;
                    this.dialogVisible = false;
                    this.loading(this.from);
                    this.Global.request_successful(res.Message);
                  } else {
                    this.losads = false;
                    this.Global.request_failure(res.Message);
                  }
                })
              }else{
                this.Global.request_failure("活动人数不能大于限制报名人数!");
                this.losads = false;
                return false;
              }
            }else{
              this.$Http_Post('activitymanagement/upeventplan', from).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  this.losads = false;
                  this.dialogVisible = false;
                  this.loading(this.from);
                  this.Global.request_successful(res.Message);
                } else {
                  this.losads = false;
                  this.Global.request_failure(res.Message);
                }
              })
            }
          } else {
            return false;
          }
        });
      }
    },
    resetForm(formName) {
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件");
      } else {
        this.loadingsss = true;
        let config = {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        };
        var fd = new FormData();
        fd.append("file", this.fileList[0]);
        fd.append("EventNo", this.EventNo);
        this.$Http_Post("ActivityManagement/AddEventAttach", fd).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadingsss = false;
            this.$refs.upload.clearFiles();
            this.fileList = [];
            this.Global.request_successful(res.Message);
            this.$Http_Post("DepartMent/GetDeparMent").then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                sessionStorage.setItem("department", JSON.stringify(res.Data));
                this.data = res.Data;
              }
            });
          } else {
            this.loadingsss = false;
            this.Global.request_failure(res.Message);
            this.dialogVisible2 = true;
            this.tableDatassss = res.Data;
            this.$refs.upload.clearFiles();
            this.fileList = [];
          }
        });
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then(_ => {
        done();
      })
      .catch(_ => { });
    },
    handleCloses(done) {
      this.$confirm('确认关闭？')
      .then(_ => {
        done();
      })
      .catch(_ => { });
    }
  },
  created() {
    let _this = this;
    this.$Http_Post('/DepartMent/getalldepartmentbynode', { DeptID: '', content: '' }).then((res) => {
      _this.options = res.Data;
    })
  },
  mounted() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: "44" }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.Classification = res.Data;
      }
    })
    this.loading(this.from);
    let _this = this;
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: "43" }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.indexval2 = res.Data;
      }
    })
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: "48" }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.Volunteer_screeningdata = res.Data;
      }
    })
    this.$Http_Post("activitymanagement/getuserlist").then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        _this.rendata = res.Data;
      }
    });
    if(this.Global.pdroleid(1062)){
      this.people = false;
    }else{
      this.people = true;
    }
    
    if(!this.Global.pdroleid(1071)){
      this.people2 = false;
    }else{
      this.people2 = true;
    }
  }
};
</script>
<style>
.Project {
  height: 100%;
}
.Project .sxgg .el-textarea{width: 473px;}
.Project .Project_top {
  height: 90px;
  width: 100%;
  background-color: #fff;
}

.Project .Project_top h2 {
  width: 98%;
  height: 50px;
  line-height: 50px;
  margin-left: 16px;
  border-bottom: 1px #E9E9E9 dashed;
  font-size: 18px;
}

.Project .Project_top .Project_div {
  height: 30px;
  margin-top: 16px;
}

.Project .Project_top .Project_div span {
  width: 80px;
  margin-left: 16px;
  float: left;
}

.Project .Project_top .Project_div ul {
  display: inline-block;
  float: left;
  margin-left: -20px;
}

.Project .Project_top .Project_div li {
  float: left;
  margin-left: 20px;
}

.Project .Project_nav {
  width: 100%;
  background-color: #fff;
  margin-top: 16px;
  height: calc(100% - 105px);
}

.Project .Project_nav_top {
  margin-left: 16px;
  padding-top: 16px;
}

.Project .el-dialog {
  width: 50% !important;
}

.Project .el-form-item__label {
  width: 150px !important;
  text-align: right;
}

.Project .el-input {
  width: 60%;
}

.Project .el-select {
  width: 90%;
}

.Project_examination li {
  border-bottom: 1px solid rgb(235 235 235);
  height: 50px;
  width: 100%;
  margin-bottom: 20px;
}

.Project_examination li p {
  float: left;
}

.Project_examination li div {
  float: right;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: #409EFF;
  color: #fff;
  width: 40px;
  border-radius: 50%;
}

.csklhi .el-form-item__content {
  margin-left: 10% !important;
  width: 80%;
}

.Project .wapprovers {
  width: 90%;
  margin-left: 5%;
  height: 500px;
  border: #bdc0c2 1px solid;
}

.Project .wapprovers .wapprovers_left input {
  width: 100% !important;
  height: 34px;
  margin-left: 10%;
  margin-top: 10px;
  background-color: #e2e2e2;
  border: none;
}

.Project .wapprovers .wapprovers_left {
  width: calc(50% - 2px);
  border-right: 1px solid #bdc0c2;
  height: 100%;
  float: left;
}

.Project .wapprovers .wapprovers_left .sxbverd {
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: #409EFF;
  color: #fff;
  width: 40px;
  border-radius: 50%;
  float: left;
  margin-left: 6px;
  margin-bottom: 10px;
}

.Project .wapprovers .wapprovers_left button {
  width: 80px;
  height: 30px;
  float: right;
  text-align: center;
  line-height: 30px;
  margin-right: 10px;
  margin-top: 10px;
}

.Project .wapprovers .wapprovers_right {
  width: 50%;
  float: left;
}

.Project .wapprovers .wapprovers_right p {
  font-size: 18px;
  margin-left: 10px;
  margin-top: 10px;
  font-weight: 500;
}

.Project .el-collapse {
  margin-left: 10%;
  width: 80%;
}

.Project .timedata {
  margin-left: 60px;
}

.Project .timedata div {
  width: 40px;
  height: 40px;
}

.Project .approverdata li {
  float: left;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: #409EFF;
  color: #fff;
  width: 40px;
  border-radius: 50%;
  margin-left: 10px;
  margin-top: 10px;
  ;
  margin-bottom: 10px;
}

.el-collapse {
  border-top: none;
}

.Project .el-cascader {
  width: 90%;
}

.el-table td,
.el-table th {
  text-align: center;
}

.Project .block {
  float: right;
  margin-top: 8px;
  margin-right: 10px;
}

.Project .lookul {
  text-align: center;
  padding-bottom: 40px;
  border-bottom: 1px solid #dbdada;
}

.Project .lookul li {
  color: rgb(32, 32, 32);
  margin-top: 20px;
  width: 80%;
  text-align: left;
  margin-left: 10%;
}

.Project .lookul li span {
  color: rgb(121, 121, 121);
}

.Project .lookdiv h6 {
  font-size: 14px;
  color: #000;
  margin-left: 10%;
  margin-top: 20px;
}
.Project .Project_top .el-input{width: 100% !important;}
.Project .Project_top .el-form-item__label{width: 80px !important;}
.Project .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}

.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 150px;}
.Project .avatar-uploader {position: absolute;top: 0px;left: 120px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 297px;width: 350px;}
.scale {margin-top: 30px;}
</style>